import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'asset-lock-icon',
  template: `
    <i class="fas fa-user-lock {{iconClass()}}"
       title="Another user is currently editing this {{item()}}"></i>
  `,
  styles: `
    :host { 
      display: contents;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AssetLockIconComponent {
  readonly iconClass = input('');
  readonly item = input('item');
}
